import { render, staticRenderFns } from "./postExcerptBlock.vue?vue&type=template&id=1e60396e&scoped=true"
import script from "./postExcerptBlock.vue?vue&type=script&lang=js"
export * from "./postExcerptBlock.vue?vue&type=script&lang=js"
import style0 from "./postExcerptBlock.vue?vue&type=style&index=0&id=1e60396e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e60396e",
  null
  
)

export default component.exports